import React from "react";

const Paragraph = ({ children }: { children: React.ReactNode }) => {
  return <p className="paragraph">{children}</p>;
};

export default Paragraph;
